// Reports.tsx
import React from "react";
import { useState } from "react";
import { FinanceData, Expense, ExtraIncome } from "../../types";
import { useMemo } from "react";

interface ReportTransactionsListProps {
  financeData: FinanceData;
}

const ReportTransactionsList: React.FC<ReportTransactionsListProps> = ({
  financeData,
}) => {
  const [showAllIcoming, setShowAllIncoming] = useState<boolean>(false);
  const [showAllOutgoing, setShowAllOutgoing] = useState<boolean>(false);

  const expensesList = useMemo(() => {
    const reversedArr: Expense[] = [...financeData.expenses].sort(
      (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
    );

    return reversedArr;
  }, [financeData]);

  const extraIncomeList = useMemo(() => {
    const reversedArr: ExtraIncome[] = [...financeData.extraIncome].sort(
      (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
    );

    return reversedArr;
  }, [financeData]);

  return (
    <div style={{ padding: "20px", maxWidth: "1200px", margin: "0 auto" }}>
      {/* Expenses Table */}
      <h2>Expenses</h2>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "20px",
        }}
      >
        <thead>
          <tr style={{ background: "#f5f5f5" }}>
            <th style={{ padding: "10px", textAlign: "left" }}>Date</th>
            <th style={{ padding: "10px", textAlign: "left" }}>Category</th>
            <th style={{ padding: "10px", textAlign: "left" }}>Amount</th>
          </tr>
        </thead>
        <tbody>
          {expensesList
            .slice(0, showAllOutgoing ? financeData.expenses.length : 3)
            .map((exp: Expense) => (
              <tr key={exp.id} style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "10px" }}>{exp.date}</td>
                <td style={{ padding: "10px" }}>
                  {exp.category}
                  {exp.customCategory && ` (${exp.customCategory})`}
                </td>
                <td style={{ padding: "10px" }}>${exp.amount}</td>
              </tr>
            ))}
        </tbody>
      </table>

      {expensesList.length > 3 && (
        <button
          onClick={() => {
            setShowAllOutgoing(!showAllOutgoing);
          }}
        >
          {showAllOutgoing ? "Show Less" : "Show All"}
        </button>
      )}

      {/* Extra Income Table */}
      <h2>Extra Income</h2>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "20px",
        }}
      >
        <thead>
          <tr style={{ background: "#f5f5f5" }}>
            <th style={{ padding: "10px", textAlign: "left" }}>Date</th>
            <th style={{ padding: "10px", textAlign: "left" }}>Description</th>
            <th style={{ padding: "10px", textAlign: "left" }}>Amount</th>
          </tr>
        </thead>
        <tbody>
          {extraIncomeList
            .slice(0, showAllIcoming ? extraIncomeList.length : 3)
            .map((inc: ExtraIncome) => (
              <tr key={inc.id} style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ padding: "10px" }}>{inc.date}</td>
                <td style={{ padding: "10px" }}>{inc.description}</td>
                <td style={{ padding: "10px" }}>${inc.amount}</td>
              </tr>
            ))}
        </tbody>
      </table>
      {extraIncomeList.length > 3 && (
        <button
          onClick={() => {
            setShowAllIncoming(!showAllIcoming);
          }}
        >
          {showAllIcoming ? "Show Less" : "Show All"}
        </button>
      )}
    </div>
  );
};

export default ReportTransactionsList;
